import { Component } from 'react';
import { toast_Time_out } from '../../Utility/Constants';
import { closeSnackbar, enqueueSnackbar } from 'notistack';
import { IconButton } from '@mui/material';
import { ImagePaths } from '../../Utility/ImagePaths';

const warningTXT = new Set([
    // old billing credit limit warning messages
    'Credit Limit Exceeded, Credit bill created successfully',
    'Credit Limit Exceeded,  Bill added to credit successfully',
    'Credit Limit Exceeded. Billing Credit Successfully',
    // new billing credit limit warning messages
    'Credit limit exceeded. Bill Created Successfully',
])
class ToastMsg extends Component {
    constructor(props) {
        super(props)
        this.state = {
            toastOpen: true,
            vertical: this.props.msgtop ? 'top' : 'bottom',
            horizontal: this.props.msgtop ? 'center' : this.props.rightside ? 'right' : 'left'
        }
    }

    // getCurrentTime = () => {
    //     return new Date().toLocaleTimeString("en-GB", { hour12: false });
    // };

    componentWillUnmount = () => {
        this.props.msgPop()
    }

    componentDidMount = () => {
        let msgText = "";
        if(typeof this.props.msg === 'string' && this.props.msg !== undefined){
           msgText =  this.props.msg
        }else{
            msgText = "Something went wrong please try again"
        }
        if (this.props.msg !== '') {
            enqueueSnackbar(msgText, {
                variant: warningTXT?.has(msgText) ? 'warning' : this.props.severity, // success, error, warning, info
                autoHideDuration: toast_Time_out,
                anchorOrigin: { vertical: this.state.vertical, horizontal: this.state.horizontal },
                invoice_number: this.props.testId,
                onExited: () => this.props.msgPop(),
                action: (id) => this.action(id),
            });
        }
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.msg !== prevProps?.msg) {
            enqueueSnackbar(this.props.msg, {
                variant: warningTXT?.has(this.props.msg) ? 'warning' : this.props.severity, // success, error, warning, info
                autoHideDuration: toast_Time_out,
                anchorOrigin: { vertical: this.state.vertical, horizontal: this.state.horizontal },
                invoice_number: this.props.testId,
                onExited: () => this.props.msgPop(),
                action: (id) => this.action(id),
            });
        }
    }

    // componentDidUpdate = (prevProps) => {
    //     if (this.props !== prevProps) {
    //         let { msg } = this.props
    //         const currentTime = this.getCurrentTime()
    //         if (msg && (msg !== this.state.lastMsg || (this.props.severity === "error" && this.state.lastMsgTime && currentTime !== this.state.lastMsgTime))) {
    //             enqueueSnackbar(this.props.msg, {
    //                 variant: this.props.severity, // success, error, warning, info
    //                 autoHideDuration: toast_Time_out,
    //                 anchorOrigin: { vertical: this.state.vertical, horizontal: this.state.horizontal },
    //                 invoice_number: this.props.testId,
    //                 onExited: () => this.props.msgPop(),
    //                 action: (id) => this.action(id),
    //             });
    //             this.setState({ lastMsg: msg, lastMsgTime: currentTime });
    //         }
    //     }
    // }

    action = snackbarId => (
        <IconButton onClick={() => { closeSnackbar(snackbarId) }}>
            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' style={{ filter: 'brightness(0) invert(1)' }} />
        </IconButton>
    );

    render() {
        return null //SnackbarProvider added in App.js
    }
}

export default ToastMsg;